import type {
  Autonomy,
  TriggerMode,
  Reversibility,
  AgentStatus,
} from "./fixtures";

/** Per-agent identity dot — same color across roster, header, agent bar, chat scope chip. */
export function StatusDot({
  color,
  status,
  size = 9,
}: {
  color: string;
  status?: AgentStatus;
  size?: number;
}) {
  return (
    <span
      className={`agui-dot${status === "paused" ? " is-paused" : ""}`}
      style={{ width: size, height: size, background: color }}
      aria-hidden="true"
    />
  );
}

const AUTONOMY_LABEL: Record<Autonomy, string> = {
  suggest: "Suggest",
  confirm: "Confirm",
  auto: "Auto",
};
export function AutonomyBadge({ level }: { level: Autonomy }) {
  return (
    <span className={`agui-badge agui-badge--autonomy agui-badge--${level}`}>
      {AUTONOMY_LABEL[level]}
    </span>
  );
}

const TRIGGER_LABEL: Record<TriggerMode, string> = {
  "one-shot": "One-shot",
  scheduled: "Scheduled",
  reactive: "Reactive",
};
export function TriggerBadge({ mode }: { mode: TriggerMode }) {
  return (
    <span className="agui-badge agui-badge--trigger">
      {TRIGGER_LABEL[mode]}
    </span>
  );
}

/** Reversibility tag — free (teal) vs sign-off (red). Consistent everywhere actions appear. */
export function ReversibilityTag({
  kind,
  label,
}: {
  kind: Reversibility;
  label?: string;
}) {
  return (
    <span
      className={`agui-tag agui-tag--${kind === "free" ? "free" : "signoff"}`}
    >
      {label ?? (kind === "free" ? "free" : "sign-off")}
    </span>
  );
}
